import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/auth";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setGoogleUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const m = location.hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sessionId = m[1];
    // Clean the hash from the URL
    window.history.replaceState({}, "", window.location.pathname);
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sessionId, ...(localStorage.getItem("cc_ref") ? { "X-Ref": localStorage.getItem("cc_ref") } : {}) },
          withCredentials: true,
        });
        setGoogleUser(res.data.business);
        nav("/app", { replace: true });
      } catch (e) {
        toast.error("Google sign-in fallito");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, setGoogleUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="display text-lg font-semibold mb-2">Autenticazione in corso…</div>
        <div className="text-sm text-muted-foreground">Un attimo di pazienza</div>
      </div>
    </div>
  );
}
